module.exports = __webpack_public_path__ + "0eff2923e67f2cb81e2c2dd08015d268.png";